import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Button from "../components/Button";
import Tag from "../components/Tag";
import {
  getScrollAnimationVariants,
  defaultScrollViewportSettings,
  staggerItemVariants,
} from "../hooks/useScrollAnimation";
import { BOOK_CALL_URLS, GET_QUOTE_URLS } from "../constants";

import "./Pricing.css";

export default function Pricing() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.startsWith("pl") ? "pl" : "en";
  const containerVariants = getScrollAnimationVariants("staggerChildren");

  return (
    <>
      <motion.section
        id="offer"
        initial="hidden"
        whileInView="visible"
        viewport={defaultScrollViewportSettings}
        variants={containerVariants}
      >
        <div className="section-title">
          <Tag>{t("pricing.pricing")}</Tag>
          <h2>
            {t("pricing.title1")}
            <br />
            {t("pricing.title2")}
          </h2>
          <p>{t("pricing.subtitle")}</p>
        </div>
        <div className="pricing-grid">
          <motion.div
            className="pricing-card pricing-card-free"
            variants={staggerItemVariants}
          >
            <div className="pricing-card-header">
              <h3>{t("pricing.free")}</h3>
              <Tag>{t("pricing.startHere")}</Tag>
            </div>
            <p className="pricing-subtitle">{t("pricing.freeSubtitle")}</p>
            <div className="pricing-price">
              <span className="price">{t("pricing.freePrice")}</span>
              <span className="price-label">
                {t("pricing.forConsultation")}
              </span>
            </div>
            <ul className="pricing-features">
              <li>{t("pricing.freeFeature1")}</li>
              <li>{t("pricing.freeFeature2")}</li>
              <li>{t("pricing.freeFeature3")}</li>
              <li>{t("pricing.freeFeature4")}</li>
            </ul>
            <Button
              className="pricing-button"
              variant="primary"
              size="small"
              href={BOOK_CALL_URLS[lang]}
              target="_blank"
            >
              {t("pricing.getStarted")}
            </Button>
          </motion.div>

          <motion.div
            className="pricing-card pricing-card-featured"
            variants={staggerItemVariants}
          >
            <div className="pricing-card-header">
              <h3>{t("pricing.designProduction")}</h3>
              <Tag className="pricing-badge">{t("pricing.recommended")}</Tag>
            </div>
            <p className="pricing-subtitle">{t("pricing.designSubtitle")}</p>
            <div className="pricing-price">
              <span className="price">{t("pricing.custom")}</span>
            </div>
            <ul className="pricing-features">
              <li>{t("pricing.designFeature1")}</li>
              <li>{t("pricing.designFeature2")}</li>
              <li>{t("pricing.designFeature3")}</li>
              <li>{t("pricing.designFeature4")}</li>
            </ul>
            <Button
              className="pricing-button"
              variant="secondary"
              size="small"
              href={GET_QUOTE_URLS[lang]}
              target="_blank"
            >
              {t("pricing.getQuote")}
            </Button>
          </motion.div>

          <motion.div className="pricing-card" variants={staggerItemVariants}>
            <div className="pricing-card-header">
              <h3>{t("pricing.production")}</h3>
            </div>
            <p className="pricing-subtitle">
              {t("pricing.productionSubtitle")}
            </p>
            <div className="pricing-price">
              <span className="price">{t("pricing.custom")}</span>
            </div>
            <ul className="pricing-features">
              <li>{t("pricing.productionFeature1")}</li>
              <li>{t("pricing.productionFeature2")}</li>
              <li>{t("pricing.productionFeature3")}</li>
              <li>{t("pricing.productionFeature4")}</li>
            </ul>
            <Button
              className="pricing-button"
              variant="secondary"
              size="small"
              href={GET_QUOTE_URLS[lang]}
              target="_blank"
            >
              {t("pricing.getQuote")}
            </Button>
          </motion.div>
        </div>
        <motion.div className="pricing-cta" variants={staggerItemVariants}>
          <span>{t("pricing.ourDeal")}</span>
          <h2>
            {t("pricing.dealDesc1")}
            <br />
            {t("pricing.dealDesc2")}
          </h2>
        </motion.div>
      </motion.section>
    </>
  );
}
